import type { InvoicePart } from '../types/invoice';

export type PaySettlementType = 'cash' | 'charge';

/** Keep in sync with `paySettlementHelpers.isCreditCardMiscFeeLine` in partbay-api. */
export function isCreditCardMiscFeeLine(part: InvoicePart): boolean {
    const t = (part.title ?? '').trim().toLowerCase();
    if (!t) return false;
    if (/\bcredit\s*card\s*fee\b/i.test(t)) return true;
    if (/\bcard\s*convenience\s*fee\b/i.test(t)) return true;
    if (/\bconvenience\s*fee\b/i.test(t) && /\bcard\b/i.test(t)) return true;
    if (/\bcard\s*processing\s*fee\b/i.test(t)) return true;
    const pn = String(part.partNumber ?? '')
        .trim()
        .toLowerCase();
    if (pn === 'misc-fee' && /\bcredit\s*card\b/i.test(t)) return true;
    if (
        /\bsurcharge\b/i.test(t) &&
        !/\b(fuel|freight|overnight|ovn|delivery|shipping|environmental|tire|epa|hazmat)\b/i.test(t)
    ) {
        return true;
    }
    return false;
}

/** Sum of credit-card / card-pricing surcharge misc lines (full `restockingFeeItems` list). */
export function sumCreditCardMiscFeeLineTotals(parts: InvoicePart[] | undefined): number {
    return (parts ?? []).filter(isCreditCardMiscFeeLine).reduce((s, p) => {
        const v = typeof p.totalBuyPrice === 'number' ? p.totalBuyPrice : 0;
        return s + v;
    }, 0);
}
